import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./styles/globals.css";
import { Toaster } from "sonner";

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <Toaster 
      position="top-right" 
      closeButton
      richColors
      duration={4000}
    />
  </>
);

